import { customEvents } from '@apia/util';
import * as React from 'react';
import { Box } from '@apia/theme';

export interface IFieldErrorMessage {
  children: React.ReactNode | string;
  name?: string;
}

export const FieldErrorMessage = ({ children, name }: IFieldErrorMessage) => {
  const [ref, setRef] = React.useState<null | HTMLDivElement>(null);

  React.useEffect(() => {
    if (children) {
      const event = new CustomEvent(customEvents.focus, { bubbles: true });
      ref?.dispatchEvent(event);
    }
  }, [children, ref]);

  if (children) {
    return (
      <Box
        ref={setRef}
        role="alert"
        data-testid={name ? `err_${name}` : null}
        sx={{
          mb: '0',
          color: 'danger',
          pt: '2',
        }}
      >
        {children}
      </Box>
    );
  }
  return null;
};
